module.exports = __webpack_public_path__ + "img/img24.f1fe4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img24.png
// module id = 265
// module chunks = 0